/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ organization: NonNullable<unknown> }} Org_Switcher_Reauth_TitleInputs */



/**
* | output |
* | --- |
* | "Sign in to {organization} again" |
*
* @param {Org_Switcher_Reauth_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const org_switcher_reauth_title = /** @type {((inputs: Org_Switcher_Reauth_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Org_Switcher_Reauth_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Erneut bei ${i?.organization} anmelden`)
	return /** @type {LocalizedString} */ (`Sign in to ${i?.organization} again`)
});